import type { OptionType } from "@/types/form";

export const symptomOptions: OptionType[] = [
  { value: "breathless", label: "Breathlessness or chest pain" },
  { value: "giddiness", label: "Giddiness" },
  { value: "pain", label: "Pain" },
  {
    value: "physical-verbal-aggression",
    label: "Physical or Verbal Aggression",
  },
];

export const assistanceOptions: OptionType[] = [
  { value: "mobility", label: "Mobility & Transfers" },
  {
    value: "bathing-toileting",
    label: "Bathing & Toileting (including diapering)",
  },
  {
    value: "meal-assistance",
    label:
      "Meal Assistance - Feeding, buying of food nearby or preparation of simple meals",
  },
  {
    value: "companionship",
    label: "Social Companionship & Activities (e.g. Going for walks, coloring)",
  },
  { value: "housekeeping", label: "Light Housekeeping Tasks" },
];

export const mobilityStatusOptions: OptionType[] = [
  {
    value: "independent",
    label: "Independent",
  },
  {
    value: "walking-assitance",
    label: "Use Walking aid or needs handhold assistance",
  },
  {
    value: "wheelchair",
    label: "Uses wheelchair or is Chair-bound",
  },
  {
    value: "bedridden-assitance",
    label: "Bedridden needing full assistance",
  },
];

export const ageOptions = Array.from({ length: 41 }, (_, i) =>
  (60 + i).toString(),
);
export const weightOptions = Array.from({ length: 13 }, (_, i) =>
  (40 + i * 5).toString(),
);

export const getSalesModalDescription =
  "If your loved one has higher or more complex care needs (i.e. wheelchair/bedridden and heavier in weight, has breathlessness or pain symptoms), our care consultants are here to help. Chat with us on WhatsApp to be matched with the right care aide.";

export const shouldOpenSalesModal = (
  mobility_status: string,
  weight: string,
): boolean => {
  const weightNum = parseInt(weight);
  return (
    weightNum > 50 &&
    (mobility_status === "wheelchair" ||
      mobility_status === "bedridden-assitance")
  );
};
